module.exports = __webpack_public_path__ + "static/img/z2.fd07de03.png";